import { render } from "./Actividades.vue?vue&type=template&id=4107c022&ts=true"
import script from "./Actividades.vue?vue&type=script&lang=ts"
export * from "./Actividades.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__